import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import middlewares from './middlewares'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes,
    base: process.env.BASE_URL,
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
})

// Executa as middlewares
middlewares.setup(router)

export default router
